import React,{useEffect, useState} from "react";
import Layout from "../../NewComponent/LayoutExpert/Layout";
import { Container, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { Form } from "react-bootstrap";
import OutOfOffice from "./OutOfOffice";
import Button from '../../NewComponent/Button/Button';
import ExpertPermissionsToggle from "./ExpertPermissionsToggle";
import { CURRENT_ROLE } from "../../API/url";
import { updateSeekerProfileData } from "../../API/api";
import { handleError } from "../../utils";
import { toast } from "react-toastify";




export default function ExpertProfilePage() {
	const dispatch = useDispatch();
	const {advanceFilterModalToggle,storeUserData} = bindActionCreators(Actions, dispatch)
	const profilePictureState = useSelector((state) => state.profilePage);
	const userState = useSelector((state)=>state.user);
	// console.log(userState.weeklyDigest,'check value')
	const [firstName, setFirstName] = React.useState(userState.firstName);
	const [lastName, setLastName] = React.useState(userState.lastName);
	const [confirmPasswd, setConfirmPassword] = React.useState("");
	const [currentPassword, setCurrentPassword] = React.useState("");
	const [isError, setError] = React.useState(null);
	const [pwdInput, initValue] = React.useState({
		password: "",
	});
	const [confirmPasswordError, setPasswordError] = React.useState(null);
	const [collapse, setCollapse] = React.useState(false);
	const ref = React.useRef(null);
	const initPwdInput = async (childData) => {
		initRobustPassword(childData);
	};
	const [isStrong, initRobustPassword] = React.useState(null);
	const [domainNames, setDomainNames] = React.useState([]);
	const [outofOfficeData, setOutofOffice] = useState(userState.outOfOffice);
	const [notificationErrorMessage, setNotificationErrorMessage] = React.useState("");
	const [color, setColor] = React.useState(false);
	const [isSubmitting, setIsSubmitting] = React.useState(false);

	const toggleButtonToast = () => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>
          Profile has been updated.
        </span>
      </>
    );
  };

	const changeFirstName = (e) => {
		setFirstName(e.target.value);
	};

	const changeLastName = (e) => {
		setLastName(e.target.value);
	};

	const clearStateValues = (e) => {
		// ref.current.value = '';
		setConfirmPassword("");
		setCurrentPassword("");
		setError("");
		pwdInput.password = "";
		setPasswordError("");
		setCollapse(!collapse);
	};


	const profilePictureModal = () => {
		advanceFilterModalToggle({ bool: true, value: "profilePicture" });
	};

	const handleCurrentPassword = (e) => {
		setCurrentPassword(e.target.value);
		if (pwdInput.password !== "" && pwdInput.password === e.target.value) {
			setError(
				<p style={{ color: "red", fontSize: "14px" }}>
					Current Password and New Password cannot be the same.
				</p>
			);
		}
		if (e.target.value === "") {
			setError(null);
		}
	};

	const onChange = (e) => {
		let password = e.target.value;
		initValue({
			...pwdInput,
			password: e.target.value,
		});
		setError(null);
		let caps, small, num, specialSymbol, charSet;
		caps = (password.match(/[A-Z]/g) || []).length;
		small = (password.match(/[a-z]/g) || []).length;
		num = (password.match(/[0-9]/g) || []).length;
		specialSymbol = (password.match(/\W/g) || []).length;
		charSet = (password.match(/{.8,}$/g) || []).length;
		if (password.length < 8) {
			setError(
				<ul style={{ paddingTop: "5px" }}>
					{/* <li style={{ color: "red", listStyle: "none" }}><i className="fa fa-times-circle" style={{ padding: "2px" }}></i>At least 8 characters</li> */}
					{charSet < 1 ? (
						<li style={{ color: "red", listStyle: "none" }}>
							<i className="fa fa-times-circle" style={{ padding: "2px" }}></i>
							At least 8 characters
						</li>
					) : (
						<li>wrong characters</li>
					)}
					{caps < 1 ? (
						<li style={{ color: "red", listStyle: "none" }}>
							<i className="fa fa-times-circle" style={{ padding: "2px" }}></i>{" "}
							At least 1 uppercase character
						</li>
					) : (
						<li style={{ color: "green", listStyle: "none" }}>
							<i className="fa fa-check-circle" style={{ padding: "2px" }}></i>
							At least 1 uppercase character
						</li>
					)}
					{small < 1 ? (
						<li style={{ color: "red", listStyle: "none" }}>
							<i className="fa fa-times-circle" style={{ padding: "2px" }}></i>
							At least 1 lowercase character
						</li>
					) : (
						<li style={{ color: "green", listStyle: "none" }}>
							<i className="fa fa-check-circle" style={{ padding: "2px" }}></i>
							At least 1 lowercase character
						</li>
					)}
					{num < 1 ? (
						<li style={{ color: "red", listStyle: "none" }}>
							<i className="fa fa-times-circle" style={{ padding: "2px" }}></i>{" "}
							At least 1 number
						</li>
					) : (
						<li style={{ color: "green", listStyle: "none" }}>
							<i className="fa fa-check-circle" style={{ padding: "2px" }}></i>
							At least 1 number
						</li>
					)}
					{specialSymbol < 1 ? (
						<li style={{ color: "red", listStyle: "none" }}>
							<i className="fa fa-times-circle" style={{ padding: "2px" }}></i>
							At least 1 special character(!,@,#,$,%,_)
						</li>
					) : (
						<li style={{ color: "green", listStyle: "none" }}>
							<i className="fa fa-check-circle" style={{ padding: "2px" }}></i>
							Password should contain at least one special character: @$!%*?&
						</li>
					)}
				</ul>
			);
			return;
		} else {
			setError(
				<ul style={{ paddingTop: "5px" }}>
					<li style={{ color: "green", listStyle: "none" }}>
						<i className="fa fa-check-circle" style={{ padding: "2px" }}></i>At
						least 8 characters
					</li>
					{caps < 1 ? (
						<li style={{ color: "red", listStyle: "none" }}>
							<i className="fa fa-times-circle" style={{ padding: "2px" }}></i>{" "}
							At least 1 uppercase character
						</li>
					) : (
						<li style={{ color: "green", listStyle: "none" }}>
							<i className="fa fa-check-circle" style={{ padding: "2px" }}></i>
							At least 1 uppercase character
						</li>
					)}
					{small < 1 ? (
						<li style={{ color: "red", listStyle: "none" }}>
							<i className="fa fa-times-circle" style={{ padding: "2px" }}></i>
							At least 1 lowercase character
						</li>
					) : (
						<li style={{ color: "green", listStyle: "none" }}>
							<i className="fa fa-check-circle" style={{ padding: "2px" }}></i>
							At least 1 lowercase character
						</li>
					)}
					{num < 1 ? (
						<li style={{ color: "red", listStyle: "none" }}>
							<i className="fa fa-times-circle" style={{ padding: "2px" }}></i>{" "}
							At least 1 number
						</li>
					) : (
						<li style={{ color: "green", listStyle: "none" }}>
							<i className="fa fa-check-circle" style={{ padding: "2px" }}></i>
							At least 1 number
						</li>
					)}
					{specialSymbol < 1 ? (
						<li style={{ color: "red", listStyle: "none" }}>
							<i className="fa fa-times-circle" style={{ padding: "2px" }}></i>
							At least 1 special character(!,@,#,$,%,_)
						</li>
					) : (
						<li style={{ color: "green", listStyle: "none" }}>
							<i className="fa fa-check-circle" style={{ padding: "2px" }}></i>
							Password should contain at least one special character: @$!%*?&
						</li>
					)}
				</ul>
			);
		}
		if (
			password === currentPassword ||
			(currentPassword !== "" && currentPassword === password)
		) {
			setError(
				<p style={{ color: "red", fontSize: "14px" }}>
					Current Password and New Password cannot be the same.
				</p>
			);
		}
		if (password !== confirmPasswd && confirmPasswd !== "") {
			setPasswordError(
				<p style={{ color: "red", fontSize: "14px" }}>Passwords don't match</p>
			);
		}
		if (password === confirmPasswd && confirmPasswd !== "") {
			setPasswordError(
				<p style={{ color: "green", fontSize: "14px" }}>Password confirmed</p>
			);
		}
	};

	const StrengthMeter = (props) => {
		const pwdValidate = props.password;
		const initPwdChecker = () => {
			let pwdCheck = 0;
			let validateRegex = ["[A-Z]", "[a-z]", "[0-9]", "\\W"];
			validateRegex.forEach((regex, i) => {
				if (new RegExp(regex).test(pwdValidate)) {
					pwdCheck += 1;
				}
			});
			switch (pwdCheck) {
				case 0:
					return {
						strength: 0,
						val: "",
					};
				case 1:
					return {
						strength: 20,
						val: "Weak",
					};
				case 2:
					return {
						strength: 40,
						val: "Fair",
					};
				case 3:
					return {
						strength: 60,
						val: "Good",
					};
				case 4:
					return {
						strength: 80,
						val: "Strong",
					};
				case 5:
					return {
						strength: 100,
						val: "Excellent",
					};
				default:
					return null;
			}
		};

		return (
			<>
				<div className="wrapper">
					<progress
						className={`pwd-checker-bar strength-${initPwdChecker().val}`}
						value={initPwdChecker().strength}
						max="100"
					/>
					<br />
					<p className="pwd-label">
						{props.password && (
							<div>
								<p className={`label strength-${initPwdChecker().val}`}>
									<strong style={{ padding: "3px" }}>
										{initPwdChecker().val}
									</strong>
								</p>
							</div>
						)}
					</p>
				</div>
			</>
		);
	};

	const handleConfirmPassword = (e) => {
		// e.persist();
		setConfirmPassword(e.target.value);
		if (pwdInput.password !== e.target.value) {
			setPasswordError(
				<p style={{ color: "red", fontSize: "14px" }}>Passwords don't match</p>
			);
		}
		if (pwdInput.password === e.target.value) {
			setPasswordError(
				<p style={{ color: "green", fontSize: "14px" }}>Password confirmed</p>
			);
		}
		if (e.target.value === "") {
			setPasswordError(null);
		}
		if (pwdInput.password === "" || pwdInput.password.length === 0) {
			setPasswordError(null);
		}
	};

	function requestPermission(e) {
		// console.log(e,'check e')
		e.preventDefault();
		Notification.requestPermission().then((permission) => {
			if (permission === "granted") {
				setNotificationErrorMessage(
					<p style={{ color: "var(--light_color_shade)", fontSize: "14px" }}>
						Notifications are enabled
					</p>
				);
				setColor(true);
			}
			if (permission === "denied") {
				setNotificationErrorMessage(
					<p style={{ color: "red", fontSize: "14px" }}>
						Permission wasn't granted. Allow a retry
					</p>
				);
			}
			if (permission === "default") {
				setNotificationErrorMessage(
					<p style={{ color: "#444", fontSize: "14px" }}>
						The permission request was dismissed
					</p>
				);
			}
		});
	}

	const onSubmit = (e) => {
    e.preventDefault();
	const weeklyDigest = sessionStorage.getItem("weeklyDigest"); // Retrieve as a string
	const weeklyDigestValue = JSON.parse(weeklyDigest) || 0;

    // e.persist();
    // const payloadData = {
    //   confirmPassword: confirmPasswd,
    //   currentPassword: currentPassword,
    //   firstName: firstName,
    //   lastName: lastName,
    //   newPassword: pwdInput.password,
    //   outOfOffice: [],
    //   questionShared: userState.expertAnswered,
    // }
    let payloadForCM = {
      firstName: firstName === "" ? userState.firstName : firstName,
      lastName: lastName === "" ? userState.lastName : lastName,
      currentPassword: currentPassword,
      newPassword: pwdInput.password,
      confirmPassword: confirmPasswd,
      newQuestion: userState.newQuestion,
      seekerRated: userState.seekerRated,
      questionShared: userState.questionShared,
      anotherExpertAnswered: userState.anotherExpertAnswered,
      newExpQuestion: userState.newExpQuestion,
      outOfOffice:userState.outOfOffice,
	  weeklyDigest:weeklyDigestValue
    }
    updateSeekerProfileData(payloadForCM).then((res) => {
      if (res===undefined) return;
      if (res.data.data !== '' && res.data.success) {
        userState.firstName = payloadForCM.firstName;
        userState.lastName = payloadForCM.lastName;
        // setIsSubmitting(true);
        let newObj = {...userState}
        storeUserData(newObj);
        clearStateValues();
        // localStorage.setItem('ngStorage-firstName', JSON.stringify(userState.firstName));
        // localStorage.setItem('ngStorage-lastName', JSON.stringify(userState.lastName));
        if (collapse === true) {
          setCollapse(!collapse)
        }
        else {
          setCollapse(collapse)
        }
        toast.success(toggleButtonToast(), {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      if (res.data.success === false || res.data.data === undefined) {
        handleError(res.data.message)
      }
    }).catch((err) => handleError(err))
  };

	const checkConditionForInputValue = () => {
		// if (
		// 	firstName.trim().length === 0 ||
		// 	firstName.trim() === "" ||
		// 	lastName.trim().length === 0 ||
		// 	lastName.trim() === "" ||
		// 	pwdInput.password === "" ||
		// 	pwdInput.password.length < 8 ||
		// 	isStrong === "Good" ||
		// 	isStrong === "Weak" ||
		// 	isStrong === "Fair" ||
		// 	isSubmitting === true ||
		// 	pwdInput.password !== confirmPasswd ||
		// 	pwdInput.password === currentPassword ||
		// 	currentPassword === "" ||
		// 	currentPassword.length === 0
		// ) {
		// 	return true;
		// }
		// else return false
		if (collapse && (pwdInput.password !=='' && currentPassword !== '' && confirmPasswd !== '')) {
			if (
				// (userState.firstName === firstName && 
				// userState.lastName === lastName) ||
				// ((userState.firstName !== firstName && userState.lastName !== lastName) &&
				// 	(pwdInput.password === "" || confirmPasswd === "" || currentPassword === "")
				// ) || 
				firstName.trim().length === 0 ||
				firstName.trim() === "" ||
				lastName.trim().length === 0 ||
				lastName.trim() === "" ||
				pwdInput.password === "" ||
				pwdInput.password.length < 8 ||
				isStrong === "Good" ||
				isStrong === "Weak" ||
				isStrong === "Fair" ||
				isSubmitting === true ||
				pwdInput.password !== confirmPasswd ||
				pwdInput.password === currentPassword ||
				currentPassword === "" ||
				currentPassword.length === 0
			) {
				return true;
			}
			
		}
		if(collapse && !((pwdInput.password !=='' && currentPassword !== '' && confirmPasswd !== '')))
		{
			if((userState.firstName === firstName && userState.lastName === lastName) || firstName === '' || lastName === '')
			{
				return true
			}
		}
		if(collapse === false)
		{
			if((userState.firstName === firstName && userState.lastName === lastName) || firstName.trim().length === 0 || lastName.trim().length === 0)
			{
				return true
			}
		}
	}

	useEffect(()=>{
		if(userState.expertTopicsData)
		{
			let arr = Object.values(userState.expertTopicsData)
			setDomainNames(arr)
		}
	},[])

	return (
		<>
			<Layout>
				<Container maxWidth="md" style={{ backgroundColor: '#fff', border: '1px solid #e0e2e6', borderRadius: '6px', marginBottom: '4%' }}>
					<Grid
						container
						rowGap={'20px'}
					>
						<Grid item xs={12} sm={12} lg={12} xl={12} md={12} padding={'16px'}>
							<Grid item lg={6} xl={6} sm={12} md={12} xs={12} textAlign="center" margin={"auto"}>
								<div style={{ marginBottom: '7px' }}>
									<img className="rounded-circle" src={profilePictureState.profilePic || require('../../Images/ProfilePictureIcon.png')} style={{ width: '126px', height: '126px', border: '1px solid #e0e2e6' }} />
								</div>
								<span onClick={() => profilePictureModal()} style={{
									color: '#5C667B', fontSize: '16px', fontWeight: 400, cursor: 'pointer', background: 'linear-gradient(to right, #00D1FF , #0075FF)',
									WebkitBackgroundClip: 'text',
									WebkitTextFillColor: 'transparent',
								}}>Update Profile Picture</span>
							</Grid>
						</Grid>
						<Grid item lg={12} md={12} padding={3} style={{ border: '1px solid #e0e2e6', borderRadius: '6px' }}>
						<h6 style={{ fontWeight: 500, fontSize: '16px', color: '#2A364A' }}>Edit Profile Info</h6>
						<Grid container spacing={3}>
						<Grid item xs={6} lg={6}>
									<p style={{ fontSize: '14px', marginBottom: 0 }}>First Name<span style={{ color: 'red' }}>*</span></p>
									<input value={firstName} onChange={(e) => changeFirstName(e)} type="text" style={{ width: '100%', border: '1px solid #e2e0e6', padding: '8px', fontSize: '14px', borderRadius: '6px' }} placeholder="Enter name" />
								</Grid>
								<Grid item xs={6} lg={6}>
									<p style={{ fontSize: '14px', marginBottom: 0 }}>Last Name<span style={{ color: 'red' }}>*</span></p>
									<input value={lastName} onChange={(e) => changeLastName(e)} type="text" style={{ width: '100%', border: '1px solid #e2e0e6', padding: '8px', fontSize: '14px', borderRadius: '6px' }} placeholder="Enter name" />
								</Grid>
								<Grid item xs={12} lg={12}>
									<p style={{ fontSize: '14px', marginBottom: 0 }}>Email</p>
									<input value={userState.email} disabled={true} type="email" style={{ width: '100%', border: '1px solid #e2e0e6', padding: '8px', fontSize: '14px', borderRadius: '6px' }} placeholder="example@gmail.com" />
								</Grid>
								<Grid item xs={12} lg={12}>
									<span style={{
										fontSize: '14px',
										textDecoration: 'underline',
										cursor: 'pointer',
										background: 'linear-gradient(to right, #00D1FF , #0075FF)',
										WebkitBackgroundClip: 'text',
										WebkitTextFillColor: 'transparent',
										position: 'relative'
									}} onClick={(e) => clearStateValues(e)}>Change Password
										<span
											style={{
												position: 'absolute',
												left: 0,
												bottom: 0,
												width: '100%',
												height: '1px',
												background: 'linear-gradient(to right, #00D1FF , #0075FF)',
											}}
										></span>
									</span>
									{collapse && (
										<>
											<Form.Group
												style={{ display: "flex", marginBottom: "15px" }}
												autoCorrect="off"
											>
												<Form.Label className="labelName col-sm-3">
													Current Password:
												</Form.Label>
												<div
													className="col-sm-6"
													style={{
														marginLeft: "12px",
													}}
												>
													<div style={{ display: "flex" }}>
														<input
															type="password"
															autocomplete="off"
															value={currentPassword}
															onChange={(e) => handleCurrentPassword(e)}
															className="form-control inputField"
															style={{ fontSize: "14px" }}
														/>
														{/* {confirmPasswordError} */}
													</div>
												</div>
											</Form.Group>
											<Form.Group
												style={{ display: "flex", marginBottom: "15px" }}
											>
												<Form.Label className="labelName col-sm-3">
													New Password:
												</Form.Label>
												<div
													className="col-sm-6"
													style={{
														marginLeft: "12px",
													}}
												>
													<input
														autoComplete="off"
														ref={ref}
														type="password"
														className="form-control inputField"
														style={{ fontSize: "14px" }}
														value={pwdInput.password}
														onChange={(e) => onChange(e)}
													></input>
													{isError !== null &&
														pwdInput.password !== "" &&
														pwdInput.password !== confirmPasswd && (
															<p className="errors"> {isError}</p>
														)}
												</div>
											</Form.Group>
											{(pwdInput.password !== "" ||
												pwdInput.password.length !== 0) &&
												pwdInput.password !== currentPassword && (
													<StrengthMeter
														password={pwdInput.password}
														actions={initPwdInput}
													/>
												)}
											<Form.Group
												style={{ display: "flex", marginBottom: "15px" }}
											>
												<Form.Label className="labelName col-sm-3">
													Confirm New Password:
												</Form.Label>
												<div
													className="col-sm-6"
													style={{
														marginLeft: "12px",
													}}
												>
													<input
														type="password"
														autoComplete="off"
														value={confirmPasswd}
														onChange={(e) => handleConfirmPassword(e)}
														className="form-control inputField"
														style={{ fontSize: "14px" }}
													></input>
													{pwdInput.password !== "" && confirmPasswordError}
												</div>
											</Form.Group>
										</>
									)}
								</Grid>
							</Grid>
						</Grid>
						<Grid item lg={12} md={12} padding={3} style={{ border: '1px solid #e0e2e6', borderRadius: '6px' }}>
							<h6 style={{fontWeight: 500, fontSize: '16px', color: 'rgb(42, 54, 74)'}}>Domains:</h6>
							{domainNames.length > 0 && domainNames.map((obj,ind)=>{
								return (<div className="domainHighlight" key={ind}>{obj}</div>)
							})}
							</Grid>
							<Grid item lg={12} xs={12} md={12} padding={3} style={{ border: '1px solid #e0e2e6', borderRadius: '6px' }}>
							<h6 style={{fontWeight: 500, fontSize: '16px', color: 'rgb(42, 54, 74)'}}>Out of Office</h6>
							<OutOfOffice firstName={userState.firstName} lastName={userState.lastName} outofOfficeData={outofOfficeData} />
					</Grid>
					<Grid item xs={12} lg={12} padding={3} style={{ border: '1px solid #e0e2e6', borderRadius: '6px' }}>
							<h6 style={{ fontWeight: 500, fontSize: '16px', color: '#2A364A' }}>Browser Notifications</h6>
							<p style={{ color: '#5C667B', fontWeight: 400, fontSize: '14px' }}>Open your browser's settings to re-enable notifications for this site</p>
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<span style={{ color: '#5C667B', fontWeight: 400, fontSize: '14px' }}>Enable Notifications</span>
								<Button 
								type={'primary'}
									onClickFunc={(e) => requestPermission(e)}
									text={'Enable Notifications'}
								/>
							</div>
							<span style={{ textAlign: 'end' }}>{notificationErrorMessage}</span>
						</Grid>
						<Grid item xs={12} lg={12} padding={3} style={{ border: '1px solid #e0e2e6', borderRadius: '6px' }}>
						<h6 style={{ fontWeight: 500, fontSize: '16px', color: '#2A364A' }}>Email Notifications</h6>
						<ExpertPermissionsToggle firstName={firstName} lastName={lastName} />
						</Grid>
						<Grid item xs={12} lg={12} marginBottom={2}>
						{checkConditionForInputValue() ? <span style={{opacity:'0.5',pointerEvents:'none'}}><Button text={'Save Changes'} type={'primary'} onClickFunc={onSubmit} /></span> : <Button text={'Save Changes'} type={'primary'} onClickFunc={onSubmit} /> }
						</Grid> 
					</Grid>
				</Container>
			</Layout>
		</>
	)
}